import { FTProcess } from '@/models/FTProcess';
import { weightToLength, initProcess, ProcessConfig, ConversionResults, ParsedVariables } from './index'
import { ConversionDetails } from '@/models/ConversionDetails';
import _ from 'lodash';

export function loadConfig({ processRow }: ParsedVariables): ProcessConfig {
  return {
    inputs: {
      goods: [
        {
          goodsType: 'laminated-material',
          goodsFilter: {
            form: ['roll']
          },
          multiple: false,
          params: [
            {
              name: 'Input Quantity',
              type: 'quantity',
              value: 'quantity',
              disabled: false
            },
            {
              name: 'Width',
              type: 'label',
              value: _.get(processRow, 'goodsObject.dimensions.width', ''),
              unit: 'mm',
              disabled: true
            }
          ]
        },
        {
          goodsType: 'wet-wipe',
          goodsFilter: {
            type: ['MRM'],
            family: ['Non Woven']
          },
          multiple: false,
          params: [
            {
              name: 'Input Quantity',
              type: 'quantity',
              value: 'quantity',
              disabled: false
            },
            {
              name: 'Width',
              type: 'label',
              value: _.get(processRow, 'goodsObject.dimensions.width', ''),
              unit: 'mm',
              disabled: true
            }
          ]
        },
        {
          goodsType: 'fragrance',
          goodsFilter: {
            type: ['ORM'],
            family: ['Fragrance']
          },
          multiple: false,
          params: [
            {
              name: 'Input Quantity',
              type: 'quantity',
              value: 'quantity',
              disabled: false
            },
            {
              name: 'Width',
              type: 'label',
              value: false,
              disabled: true
            }
          ]
        },
        {
          goodsType: 'ethanol',
          goodsFilter: {
            type: ['ORM'],
            family: ['Chemical']
          },
          multiple: false,
          params: [
            {
              name: 'Input Quantity',
              type: 'quantity',
              value: 'quantity',
              disabled: false
            },
            {
              name: 'Width',
              type: 'label',
              value: false,
              disabled: true
            }
          ]
        }
      ]
    },
    outputs: {
      type: 'single',
      arguments: [
        {
          name: 'Width',
          type: 'label',
          value: _.get(processRow, 'ftProcess.ftFactoryTicket.order.product.size.WIDTH', ''),
          unit: 'mm',
          disabled: true
        },
        {
          name: 'Length',
          type: 'label',
          value: _.get(processRow, 'ftProcess.ftFactoryTicket.order.product.size.LENGTH', ''),
          unit: 'mm',
          disabled: true
        },
        {
          name: 'With Neck Cut',
          type: 'checkbox',
          value: 'hasNeckCut',
          disabled: false
        }
      ]
    },
    tableHeaders: [
      {
        text: 'Nominal Speed',
        value: 'nominalSpeed'
      },
      {
        text: 'Piece(s) per stroke',
        value: 'pcsPerStroke'
      },
      {
        text: 'Planned Hours(s)',
        value: 'plannedHours'
      },
      {
        text: 'Number Of Pieces',
        value: 'numberOfPieces'
      },
      {
        text: 'Expected Output Waste',
        value: 'wastePercentage'
      },
      {
        text: 'Expected Output Waste Weight',
        value: 'waste'
      },
      {
        text: 'Expected Output Net Weight',
        value: 'netWeight'
      }
    ]
  }
}

export function convert(process: FTProcess) : ConversionResults {
  const conversionResult : ConversionResults = {
    inputs: [],
    outputs: [],
    details: new ConversionDetails(),
  };

  initProcess(process);

  let laminatedMaterialWidth = 0;
  conversionResult.details.totalQuantity = 0;
  const laminatedMaterialFTProcessRow =  process.inputs[0];
  const wetWipeFTProcessRow = process.inputs[1];
  const fragranceFTProcessRow = process.inputs[2];
  const ethanolFTProcessRow = process.inputs[3];
  const outputFTProcessRow = process.outputs[0];
  conversionResult.outputs[0] = outputFTProcessRow;

  const sachetWidth = process.ftFactoryTicket.order.product.size.WIDTH;
  const sachetLength = process.ftFactoryTicket.order.product.size.LENGTH;
  laminatedMaterialWidth = laminatedMaterialFTProcessRow.goodsObject.dimensions ? laminatedMaterialFTProcessRow.goodsObject.dimensions.width : 0;
  let linearMeters = 0;
  if(laminatedMaterialFTProcessRow.quantity) {
    linearMeters = weightToLength(laminatedMaterialFTProcessRow.quantity, laminatedMaterialFTProcessRow.goodsObject.density, laminatedMaterialWidth);
  }
  const numberOfPieces = ((linearMeters * 1000)* laminatedMaterialWidth) / (sachetLength * sachetWidth * 2); // Multiplied by 2 to account for both front and back
  outputFTProcessRow.goodsObject.copyFrom(laminatedMaterialFTProcessRow.goodsObject);
  outputFTProcessRow.quantity = laminatedMaterialFTProcessRow.quantity + wetWipeFTProcessRow.quantity + fragranceFTProcessRow.quantity + _.get(ethanolFTProcessRow, 'quantity', 0);
  outputFTProcessRow.goodsObject.unitWeight = outputFTProcessRow.quantity / numberOfPieces;
  const value = numberOfPieces / outputFTProcessRow.quantity;
  outputFTProcessRow.goodsObject.setPerKgRatio('plA', value);

  conversionResult.details.numberOfPieces = numberOfPieces;
  if (process.machineDetail.pcsPerStroke) {
      conversionResult.details.kgPerHour = 60 * outputFTProcessRow.goodsObject.unitWeight * process.machineDetail.mechanicalSpeed * process.machineDetail.pcsPerStroke;
      conversionResult.details.plannedHours = (conversionResult.details.numberOfPieces * outputFTProcessRow.goodsObject.unitWeight) / conversionResult.details.kgPerHour;
  }
  conversionResult.details.wastePercentage = 0;
  conversionResult.details.waste = 0;
  conversionResult.details.netWeight = outputFTProcessRow.quantity;
  conversionResult.details.pcsPerStroke = process.machineDetail.pcsPerStroke;

  return conversionResult;
}